import React from 'react'
import { Text } from '../Text'

interface Props {
    /** Aria label describes what the value of the badge represents */
    ariaLabel: string
    /** The count to display in the badge */
    count: number
}

/** Shows a badge with a count. If count is 0, the badge is not shown. */
export const Badge = ({ ariaLabel, count }: Props) => {
    if (count === 0) {
        return null
    }

    return (
        <div
            className="badge w-5 h-5 rounded-full bg-accent-700 inline-flex items-center justify-center"
            aria-label={ariaLabel}
        >
            <Text className="text-white text-xs" tag="span">
                {count}
            </Text>
        </div>
    )
}
